import dayjs from 'dayjs';
import { forwardRef } from 'react';
import { useTheme } from '@mui/material';
import { EmailRounded } from '@mui/icons-material';

import { Timeline } from '../Timeline';
import { MessageHeader } from './components/MessageHeader';
import { MessageContent } from './components/MessageContent';
import { useImagePreview } from './hooks/useImagePreview';
import { MessageContainer, MessageStack } from './styled';
import { MessageProps } from './types';
import { ImagePreviewDialog } from '../ImagePreviewDialog';

export const EmailItem = forwardRef<HTMLDivElement, MessageProps>(({ history, isCurrentUser }, ref) => {
  const { previewImage, handleEditorClickEvent, handleClosePreview } = useImagePreview();
  const theme = useTheme();

  const createdAtTime = dayjs(history.createdAt).format('HH:mm');
  const createdAtDate = dayjs(history.createdAt).format('D MMM YYYY');
  const fromFullName = `${history.authorFirstName || ''} ${history.authorLastName || ''}`;
  const authorName = fromFullName.trim() || history.emailFrom;

  return (
    <MessageContainer ref={ref} sx={{ justifyContent: isCurrentUser ? 'flex-end' : 'flex-start' }}>
      <MessageStack
        order={isCurrentUser ? 1 : 2}
        sx={{
          mr: (theme) => theme.spacing(isCurrentUser ? 2.5 : 0),
          ml: (theme) => theme.spacing(isCurrentUser ? 0 : 2.5),
        }}
      >
        <MessageHeader authorName={authorName} isCurrentUser={isCurrentUser} />
        <MessageContent
          history={history}
          isCurrentUser={isCurrentUser}
          createdAtTime={createdAtTime}
          createdAtDate={createdAtDate}
          handleEditorClickEvent={handleEditorClickEvent}
        />
      </MessageStack>
      <Timeline
        isCurrentUser={isCurrentUser}
        icon={EmailRounded}
        color={theme.palette.background.paper}
        background={theme.palette.grey[600]}
      />
      <ImagePreviewDialog previewImage={previewImage} onClose={handleClosePreview} />
    </MessageContainer>
  );
});

EmailItem.displayName = 'EmailItem';
